// extracted by mini-css-extract-plugin
export var project_card = "Project-module--project_card--2BoN5";
export var description = "Project-module--description--jVdIs";
export var disable = "Project-module--disable--2IW7O";